module.exports = __webpack_public_path__ + "static/media/arcos.b8679275.jpg";